<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisModal from 'dashboard/components-next/LaisModal.vue';
import LaisCopyButton from 'dashboard/components-next/LaisCopyButton.vue';

defineProps({
  show: { type: Boolean, default: false },
  link: { type: String, default: '' },
});

const emit = defineEmits(['close']);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisModal
    :show="show"
    title="Responsável pelas chaves"
    max-width-class="max-w-[480px]"
    @close="emit('close')"
  >
    <div class="grid gap-3 text-[14px] text-lais-text-body">
      <p>
        Quando não houver responsável por chaves cadastrado, copie o link de
        localização e envie para quem fará a liberação da entrada.
      </p>
      <LaisCopyButton v-if="link" :text="link" label="Copiar link" />
    </div>
  </LaisModal>
</template>
